import React from 'react';

import clsx from 'clsx';
import { NavIcon } from 'components';

import { Ellipsis } from 'components/Ellipsis/Ellipsis';

interface BadgeProps {
  label: string;
  size?: 'sm' | 'md';
  color?: string;
  showEllipsis?: boolean;
  iconSrc?: string;
  iconPosition?: 'left' | 'right';
}

export const Badge: React.FC<BadgeProps> = ({
  label,
  color = clsx('text-primary-600', 'bg-white'),
  size = 'md',
  showEllipsis,
  iconSrc,
  iconPosition = 'left',
}) => {
  return (
    <div
      data-testid={`badge-${label}`}
      className={clsx(
        'font-semibold',
        {
          'text-xs h-6': size === 'md',
          'py-1': size === 'md',
          'px-2': size === 'md',
        },
        {
          'text-3xs h-4': size === 'sm',
          'py-0': size === 'sm',
          'px-2': size === 'sm',
        },
        {
          'flex-row': iconPosition === 'left',
          'flex-row-reverse': iconPosition === 'right',
        },
        'leading-4',
        'border',
        'uppercase',
        'rounded',
        'flex',
        'justify-center',
        'w-fit',
        'gap-2',
        'whitespace-nowrap',
        color
      )}
    >
      {iconSrc && (
        <NavIcon
          data-testid={`badge-icon-${label}`}
          source={iconSrc}
          size="xs"
          alt={`${label}-icon`}
        />
      )}

      {showEllipsis ? (
        <Ellipsis className="max-w-[112px] lg:max-w-[90px] xl:max-w-[112px]">
          {label}
        </Ellipsis>
      ) : (
        label
      )}
    </div>
  );
};
